"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const SendTestComponentLayout = ({ children, userDeviceType, sendTestModalDisplay, }) => {
    if (userDeviceType === 'Mobile') {
        return (React.createElement("div", { id: "sendTestId", style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '100%',
                zIndex: 2,
                position: 'absolute',
                background: src_1.white,
                top: 0,
                left: 0,
                animation: `${sendTestModalDisplay} 300ms ease`,
                overflowY: 'scroll',
            } },
            React.createElement("div", { style: {
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                } }, children)));
    }
    return (React.createElement("div", { style: {
            display: 'flex',
            flexDirection: 'column',
        } }, children));
};
exports.default = SendTestComponentLayout;
